// Centralización de variables de entorno
// Todas las env vars se leen desde aquí para evitar dispersión

const env = {
  CALCULATOR_API_URL: process.env.REACT_APP_CALCULATOR_API_URL || '',
  CONTENT_API_URL: process.env.REACT_APP_CONTENT_API_URL || '',
  COMMENTS_API_URL: process.env.REACT_APP_COMMENTS_API_URL || '',
  ADMIN_API_URL: process.env.REACT_APP_ADMIN_API_URL || '',
  MARKDOWN_API_URL: process.env.REACT_APP_MARKDOWN_API_URL || '',
  TURNSTILE_SITE_KEY: process.env.REACT_APP_TURNSTILE_SITE_KEY || '',
  GA_ID: process.env.REACT_APP_GA_ID || '',
  SITE_URL: process.env.REACT_APP_SITE_URL || 'https://www.creditools.com.mx',
  CALENDAR_URL: process.env.REACT_APP_CALENDAR_URL || '',
  COMMENTS_PROVIDER: (process.env.REACT_APP_COMMENTS_PROVIDER || 'facebook').toLowerCase(),
  DISQUS_SHORTNAME: process.env.REACT_APP_DISQUS_SHORTNAME || '',
  FACEBOOK_COMMENTS_LOCALE: process.env.REACT_APP_FACEBOOK_COMMENTS_LOCALE || 'es_LA',
  ENABLE_LOCAL_FALLBACK: process.env.REACT_APP_ENABLE_LOCAL_FALLBACK !== 'false',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
};

// Validación en desarrollo
if (!env.IS_PRODUCTION && !env.CALCULATOR_API_URL) {
  console.warn(
    '[Creditools] REACT_APP_CALCULATOR_API_URL no está configurada. La calculadora no funcionará.'
  );
}

if (!env.IS_PRODUCTION && !env.CONTENT_API_URL) {
  console.warn(
    '[Creditools] REACT_APP_CONTENT_API_URL no está configurada. El blog, productos y admin CMS usarán fallback local o fallarán.'
  );
}

if (!env.IS_PRODUCTION && !env.MARKDOWN_API_URL) {
  console.warn(
    '[Creditools] REACT_APP_MARKDOWN_API_URL no está configurada. El convertidor a Markdown usará mensajes de configuración pendiente.'
  );
}

if (!env.IS_PRODUCTION && !env.TURNSTILE_SITE_KEY) {
  console.warn(
    '[Creditools] REACT_APP_TURNSTILE_SITE_KEY no está configurada. Los formularios protegidos permanecerán deshabilitados.'
  );
}

if (!env.IS_PRODUCTION && !env.GA_ID) {
  console.warn('[Creditools] REACT_APP_GA_ID no está configurada. Google Analytics permanecerá deshabilitado.');
}

export default env;
